import { object, string, mixed, number, array, lazy, SchemaOf } from 'yup';

import {
  CategorizationRule,
  GroupCondition,
  RuleCondition,
  SingleCondition,
} from 'src/common/interfaces/categorization-dashboard';
import { ContextType, FrequencyType, GroupOperatorType, OperatorType } from 'src/common/enums/categorization-dashboard';

export const singleConditionInitialValue: SingleCondition = {
  type: 'single',
  source: '',
  field: '',
  operator: OperatorType.EQUALS,
  value: '',
  frequency: undefined,
};

export const groupConditionInitialValue: GroupCondition = {
  type: 'group',
  operator: GroupOperatorType.AND,
  conditions: [singleConditionInitialValue],
  frequency: undefined,
};

export const nestedRuleInitialValue: RuleCondition = {
  type: 'rule',
  ruleId: '',
  frequency: undefined,
};

export const ruleInitialValue: CategorizationRule = {
  _id: '',
  title: '',
  description: '',
  category: '',
  type: ContextType.GENERIC,
  condition: groupConditionInitialValue,
  contexts: [],
};

const frequencyValidation = object({
  amount: number().label('Amount'),
  type: mixed<FrequencyType>().oneOf(Object.values(FrequencyType)).label('Type'),
});

const singleConditionValidation = object({
  source: string().required().label('Source'),
  field: string().required().label('Field'),
  operator: mixed<OperatorType>().oneOf(Object.values(OperatorType)).required().label('Operator'),
  value: mixed().required().label('Value'),
  frequency: frequencyValidation.notRequired().label('Frequency'),
});

const ruleConditionValidation = object({
  ruleId: string().required().label('Rule'),
  parameters: object().notRequired().label('Parameters'),
  frequency: frequencyValidation.notRequired().label('Frequency'),
});

const groupConditionValidation: SchemaOf<GroupCondition> = lazy(() =>
  object({
    operator: mixed().oneOf(Object.values(GroupOperatorType)).required().label('Operator'),
    frequency: frequencyValidation.notRequired().label('Frequency'),
    conditions: array().of(conditionValidation).required().label('Conditions'),
  }),
) as unknown as SchemaOf<GroupCondition>;

const conditionValidation = mixed()
  .test(
    'is-valid-condition',
    (value) =>
      singleConditionValidation.isValidSync(value) ||
      ruleConditionValidation.isValidSync(value) ||
      groupConditionValidation.isValidSync(value),
  )
  .required();

export const categorizationRuleValidation = object({
  title: string().required().label('Title'),
  description: string().label('Description'),
  category: string().required().label('Category'),
  condition: conditionValidation.label('Condition'),
  contexts: array().of(string()).label('Contexts'),
});
